webpackJsonp([29],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	__webpack_require__(10);
	__webpack_require__(16);
	__webpack_require__(15);
	__webpack_require__(115);

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	'use strict';
	
	rwgps.ns('ambassadors.show', function () {
	  var ns = this,
	      AmbassadorView;
	
	  ns.init = function () {
	    ns.view = new AmbassadorView();
	  };
	
	  AmbassadorView = Backbone.View.extend({
	    el: 'body',
	    initialize: function initialize() {
	      this.initPostcards(ns.postcards);
	      this.enableResponsiveHooks();
	    },
	    initPostcards: function initPostcards(postcards) {
	      this.postcards = [];
	      _.each(postcards, function (postcard) {
	        this.postcards.push(new rwgps.postcards.Postcard('#postcard-ar-' + postcard.associated_object_id, {
	          layout: JSON.parse(postcard.layout),
	          disableFilmstrip: true,
	          editedImageUrls: postcard.edited_image_urls
	        }));
	      }, this);
	    },
	    enableResponsiveHooks: function enableResponsiveHooks() {
	      var view = this;
	      view.isMobile = false;
	
	      function mediaChange() {
	        _.each(view.postcards, function (pc) {
	          if (view.isMobile) {
	            pc.$container.closest('.ambassador-route-postcard').addClass('fluid');
	            pc.enableFluid();
	          } else {
	            pc.$container.closest('.ambassador-route-postcard').removeClass('fluid');
	            pc.disableFluid();
	          }
	        });
	      }
	
	      function checkMedia() {
	        var isMobileNow = $(".ambassador-brand").css("float") == "none";
	
	        if (isMobileNow !== view.isMobile) {
	          view.isMobile = isMobileNow;
	          mediaChange();
	        }
	      }
	
	      $(window).resize(checkMedia);
	      checkMedia();
	    },
	    events: {
	      'click .ambassador_route .change_route': 'toggleChangeRoute',
	      'click .ambassador_route_form .cancel': 'cancelChangeRoute'
	    },
	    toggleChangeRoute: function toggleChangeRoute(e) {
	      var $ar = $(e.currentTarget).closest('.ambassador_route');
	      $ar.find('.ambassador_route_form').show();
	      $ar.find('.selected_route').hide();
	    },
	    cancelChangeRoute: function cancelChangeRoute(e) {
	      var $ar = $(e.currentTarget).closest('.ambassador_route');
	      $ar.find('.ambassador_route_form').hide();
	      $ar.find('.selected_route').show();
	    }
	  });
	});

/***/ })

});


// WEBPACK FOOTER //
// ambassadors-show-d055df6634e4e64e4623-bundle.js